export const mentorSupportPayoutLocalization = {
  headerTitle: {
    nb: 'Utbetaling av støtte til mentor',
    nn: 'Utbetaling av støtte til mentor',
    en: 'Mentor support payout',
  },
  summaryTitle: {
    nb: 'Oppsummering og innsending',
    nn: 'Oppsummering og innsending',
    en: 'Summary and submission',
  },
  confirmSectionTitle: {
    nb: 'Bekreft før innsending',
    nn: 'Bekreft før innsending',
    en: 'Confirm before submission',
  },
  confirmCheckbox1: {
    nb: 'Jeg bekrefter at opplysningene jeg har oppgitt stemmer',
    nn: 'Eg stadfestar at opplysningane eg har oppgitt stemmer',
    en: 'I confirm that the information I have provided is correct',
  },
  confirmCheckbox2: {
    nb: 'Jeg bekrefter at jeg har lest og er kjent med Innovasjon Norges betingelser og vilkår for utbetaling av tilskudd',
    nn: 'Eg stadfestar at eg har lese og er kjend med Innovasjon Noreg sine vilkår for utbetaling av tilskot',
    en: 'I confirm that I have read and am familiar with Innovation Norway’s terms and conditions for grant payout',
  },
  conditionsTitle: {
    nb: 'Betingelser og vilkår',
    nn: 'Vilkår og betingelser',
    en: 'Terms and conditions',
  },
  condition1: {
    nb: 'Utbetalingsanmodningen kan kun sendes inn etter at mentorordningen er gjennomført',
    nn: 'Utbetalingsanmodninga kan berre sendast inn etter at mentorordninga er gjennomført',
    en: 'The payout request can only be submitted after the mentor program has been completed',
  },
  condition2: {
    nb: 'Oppgitt kontonummer for utbetaling må tilhøre låntaker/støttemottaker',
    nn: 'Oppgitt kontonummer for utbetaling må tilhøyre låntakar/støttemottakar',
    en: 'The specified account number for payout must belong to the borrower/recipient',
  },
  condition3: {
    nb: 'Vedlagte faktura eller betalingsbilag er kun forbundet med mentortimer',
    nn: 'Vedlagte faktura eller betalingsbilag er berre forbundet med mentortimar',
    en: 'Attached invoice or payment voucher is only related to mentor hours',
  },
  condition4: {
    nb: 'Ingen vedlagte faktura gjelder lønnskostnader, reise, opphold eller bevertning eller annet',
    nn: 'Ingen vedlagte faktura gjeld lønskostnader, reise, opphald eller bevertning eller anna',
    en: 'No attached invoice applies to salary costs, travel, accommodation, hospitality or other',
  },
  condition5: {
    nb: 'Mentor skal ikke ha påtatt seg oppgaver for bedriften',
    nn: 'Mentor skal ikkje ha påteke seg oppgåver for bedrifta',
    en: 'The mentor must not have taken on tasks for the company',
  },
  // GrantApplicationIntroPage
  grantApplicationTitle: {
    nb: 'Du søker om utbetaling av tilskudd for:',
    nn: 'Du søkjer om utbetaling av tilskot for:',
    en: 'You are applying for mentor support payout for:',
  },
  grantApplicationIntro: {
    nb: 'Veiledningen fra mentor må være gjennomført før du kan be om utbetaling. Du kan kun søke om én utbetaling av støtte til mentor.',
    nn: 'Rettleiinga frå mentor må vere gjennomført før du kan be om utbetaling. Du kan berre søkje om éi utbetaling av støtte til mentor.',
    en: 'The mentor guidance must be completed before you can request a payout. You can only apply for one mentor support payout.',
  },
  offerLetter: {
    nb: 'TILBUDSBREV',
    nn: 'TILBODSBREV',
    en: 'OFFER LETTER',
  },
  payoutDetails: {
    nb: 'Detaljer for utbetaling',
    nn: 'Detaljar for utbetaling',
    en: 'Payout details',
  },
  customer: {
    nb: 'Kunde',
    nn: 'Kunde',
    en: 'Customer',
  },
  reference: {
    nb: 'Referanse',
    nn: 'Referanse',
    en: 'Reference',
  },
  grant: {
    nb: 'Tilskudd',
    nn: 'Tilskot',
    en: 'Grant',
  },
  instrumentCode: {
    nb: 'Virkemiddelkode',
    nn: 'Virkemiddelkode',
    en: 'Instrument code',
  },
  grantedDate: {
    nb: 'Innvilget dato',
    nn: 'Innvilga dato',
    en: 'Granted date',
  },
  availableAmount: {
    nb: 'Tilgjengelig beløp',
    nn: 'Tilgjengeleg beløp',
    en: 'Available amount',
  },
  receivedMentorGuidanceLabel: {
    nb: 'Har du mottatt veiledning fra mentor?',
    nn: 'Har du fått rettleiing frå mentor?',
    en: 'Have you received guidance from a mentor?',
  },
  receivedMentorGuidanceYes: {
    nb: 'Ja',
    nn: 'Ja',
    en: 'Yes',
  },
  receivedMentorGuidanceNo: {
    nb: 'Nei, vi har ikke mottatt veiledning, eller er ikke ferdige',
    nn: 'Nei, vi har ikkje fått rettleiing, eller er ikkje ferdige',
    en: 'No, we have not received guidance, or are not finished',
  },

  // PaymentDetailsFormPage
  paymentInfoTitle: {
    nb: 'Utbetalingsinformasjon og dokumentasjon',
    nn: 'Utbetalingsinformasjon og dokumentasjon',
    en: 'Payout information and documentation',
  },
  payoutAmountLabel: {
    nb: 'Utbetalingsbeløp',
    nn: 'Utbetalingsbeløp',
    en: 'Payout amount',
  },
  payoutAmountHelpText: {
    nb: 'Du kan be om utbetaling for kostnader opp til kr {0},-. Støtten gjelder kun kostnader for mentortimer.',
    nn: 'Du kan be om utbetaling for kostnader opp til kr {0},-. Støtta gjeld berre kostnader for mentortimar.',
    en: 'You can request a payout for costs up to NOK {0},-. The support only covers costs for mentor hours.',
  },
  accountNumberLabel: {
    nb: 'Kontonummer for utbetaling',
    nn: 'Kontonummer for utbetaling',
    en: 'Account number for payout',
  },
  accountNumberHelp: {
    nb: 'Kontonummer må tilhøre støttemottaker',
    nn: 'Kontonummer må tilhøyre støttemottakar',
    en: 'Account number must belong to the recipient',
  },
  documentationTitle: {
    nb: 'Dokumentasjon',
    nn: 'Dokumentasjon',
    en: 'Documentation',
  },
  documentationInfo: {
    nb: 'Støtten gjelder kun kostnader for mentortimer. Innovasjon Norge støtter ikke lønnskostnader eller kostnader forbundet med reise, opphold, bevertning eller annet for mentor. Mentor skal ikke ha påtatt seg oppgaver for bedriften.',
    nn: 'Støtta gjeld berre kostnader for mentortimar. Innovasjon Noreg støttar ikkje lønskostnader eller kostnader for reise, opphald, bevertning eller anna for mentor. Mentor skal ikkje ha påteke seg oppgåver for bedrifta.',
    en: 'The support only covers costs for mentor hours. Innovation Norway does not support salary costs or costs related to travel, accommodation, hospitality or other for the mentor. The mentor must not have taken on tasks for the company.',
  },
  uploadVoucherLabel: {
    nb: 'Last opp faktura eller betalingsbilag fra mentor (maks 1 fil)',
    nn: 'Last opp faktura eller betalingsbilag frå mentor (maks 1 fil)',
    en: 'Upload invoice or payment voucher from mentor (max 1 file)',
  },
  allowedFileTypes: {
    nb: 'Du kan laste opp følgende filtyper: .pdf, .docx, .xlsx, .odt og .ods',
    nn: 'Du kan laste opp følgjande filtypar: .pdf, .docx, .xlsx, .odt og .ods',
    en: 'You can upload the following file types: .pdf, .docx, .xlsx, .odt and .ods',
  },
  // FinalReportPage
  finalReportTitle: {
    nb: 'Sluttrapport',
    nn: 'Sluttrapport',
    en: 'Final report',
  },
  finalReportAgreementTitle: {
    nb: 'I hvilken grad er du enig i påstandene nedenfor?',
    nn: 'I kva grad er du einig i påstandane nedanfor?',
    en: 'To what extent do you agree with the statements below?',
  },
  finalReportFeedbackNotice: {
    nb: 'Tilbakemeldingene vil ikke påvirke utbetalingen.',
    nn: 'Tilbakemeldingane vil ikkje påverke utbetalinga.',
    en: 'The feedback will not affect the payout.',
  },

  mentorContributionScoreOptions_0: {
    nb: 'Helt enig',
    nn: 'Helt einig',
    en: 'Completely agree',
  },
  mentorContributionScoreOptions_1: {
    nb: 'Litt enig',
    nn: 'Litt einig',
    en: 'Somewhat agree',
  },
  mentorContributionScoreOptions_2: {
    nb: 'Nøytral',
    nn: 'Nøytral',
    en: 'Neutral',
  },
  mentorContributionScoreOptions_3: {
    nb: 'Litt uenig',
    nn: 'Litt uenig',
    en: 'Somewhat disagree',
  },
  mentorContributionScoreOptions_4: {
    nb: 'Helt uenig',
    nn: 'Helt uenig',
    en: 'Completely disagree',
  },

  mentorContributionScoreLabel: {
    nb: 'Mentorens bidrag har hjulpet deres bedrift med spesifikke utfordringer',
    nn: 'Mentoren sitt bidrag har hjelpt deira verksemd med spesifikke utfordringar',
    en: 'The mentor’s contribution has helped your company with specific challenges',
  },
  mentorGuidanceScoreLabel: {
    nb: 'Mentorens råd og kompetanse har påvirket bedriftens strategi eller beslutninger',
    nn: 'Mentoren sine råd og kompetanse har påverka verksemda si strategi eller avgjerder',
    en: 'The mentor’s advice and expertise have influenced your company’s strategy or decisions',
  },
  mentorAdviceAdherenceLabel: {
    nb: 'Hvordan vil du vurdere bedriftens evne og mulighet til å følge rådene fra mentor?',
    nn: 'Korleis vil du vurdere verksemda si evne og moglegheit til å følgje råda frå mentor?',
    en: 'How would you assess your company’s ability and opportunity to follow the mentor’s advice?',
  },
  mentorAdviceAdherenceHelp: {
    nb: 'Hadde dere tid, kapasitet og ressurser til å følge rådene som ble gitt av mentor?',
    nn: 'Hadde de tid, kapasitet og ressursar til å følgje råda som blei gitt av mentor?',
    en: 'Did you have the time, capacity and resources to follow the advice given by the mentor?',
  },
  wouldRecommendMentorLabel: {
    nb: 'Vil du anbefale mentoren dere fikk tildelt til andre selskaper i samme fase?',
    nn: 'Vil du tilrå mentoren de fekk tildelt til andre selskap i same fase?',
    en: 'Would you recommend the mentor you were assigned to other companies in the same phase?',
  },
  howWasCollaborationWithMentorPerceivedLabel: {
    nb: 'Hvordan opplevde dere samarbeidet med mentoren?',
    nn: 'Korleis opplevde de samarbeidet med mentoren?',
    en: 'How did you experience the collaboration with the mentor?',
  },
  wouldRecommendINMentorSupportLabel: {
    nb: 'Vil du anbefale Innovasjon Norges mentorordning til andre selskaper i samme bransje?',
    nn: 'Vil du tilrå Innovasjon Noreg si mentorordning til andre selskap i same bransje?',
    en: 'Would you recommend Innovation Norway’s mentor program to other companies in the same industry?',
  },
  whatCouldMakeMentorSupportMoreRelevantLabel: {
    nb: 'Hva kunne ha gjort mentorordningen mer relevant for dere?',
    nn: 'Kva kunne gjort mentorordninga meir relevant for dykk?',
    en: 'What could have made the mentor program more relevant for you?',
  },
  requiredFieldErrorMessage: {
    nb: 'Dette feltet er påkrevd',
    nn: 'Dette feltet er påkravd',
    en: 'This field is required',
  },
  maxLengthErrorMessage: {
    nb: 'Maks 500 tegn',
    nn: 'Maks 500 teikn',
    en: 'Max 500 characters',
  },
  mentorAdviceAdherenceRequired: {
    nb: 'Vurdering av bedriftens evne til å følge mentorens råd er påkrevd',
    nn: 'Vurdering av verksemda si evne til å følgje mentoren sine råd er påkravd',
    en: 'Assessment of company ability to follow mentor advice is required',
  },
  howWasCollaborationWithMentorPerceivedRequired: {
    nb: 'Beskrivelse av samarbeidet med mentoren er påkrevd',
    nn: 'Beskriving av samarbeidet med mentoren er påkravd',
    en: 'Description of collaboration with mentor is required',
  },
  whatCouldMakeMentorSupportMoreRelevantRequired: {
    nb: 'Tilbakemelding om hvordan mentorordningen kunne blitt mer relevant er påkrevd',
    nn: 'Tilbakemelding om korleis mentorordninga kunne blitt meir relevant er påkravd',
    en: 'Feedback on how mentor program could be more relevant is required',
  },

  receivedMentorGuidanceRequired: {
    nb: 'Veiledningen fra mentor må være gjennomført før du kan be om utbetaling',
    nn: 'Rettleiinga frå mentor må vere gjennomført før du kan be om utbetaling',
    en: 'The guidance from the mentor must be completed before you can request a payout',
  },

  // mustChooseAtleastOneAlternative: {
  //   nb: 'Du må velge minst ett alternativ',
  //   nn: 'Du må velje minst eitt alternativ',
  //   en: 'You must choose at least one alternative',
  // },

  payoutAmountMaxErrorMessage: {
    nb: 'Maksimalt utbetalingsbeløp er ',
    nn: 'Maksimalt utbetalingsbeløp er ',
    en: 'The maximum payout amount is ',
  },
  waitingDownloadFileMessage: {
    nb: 'Et øyeblikk - vi forbereder filen din',
    nn: 'Eit augneblink - vi førebur fila di',
    en: 'Just a moment - preparing your file',
  },
} as const;
